import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("uee_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Per-request unit selector (Unit 01 / Unit 02). Defaults to unit1 so any
  // existing flow that doesn't explicitly pick a unit keeps printing PDFs
  // with the original Head Office letterhead.
  const unit = localStorage.getItem("uee_unit") || "unit1";
  config.headers["X-Active-Unit"] = unit;
  // X-Admin-Scope tells the backend "this request originated from inside the
  // admin panel" — backend applies unit isolation filtering only when this
  // header is `true`. Public website pages (Home, Products, News, About,
  // Contact) never send it, so they continue to display ALL units' content
  // regardless of who is logged in.
  if (
    typeof window !== "undefined" &&
    window.location?.pathname?.startsWith("/admin")
  ) {
    config.headers["X-Admin-Scope"] = "true";
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("uee_token");
    }
    return Promise.reject(err);
  }
);

export const FILE_BASE = process.env.REACT_APP_BACKEND_URL;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  return String(detail);
}

export default api;
